<template>
  <b-modal id="upload_timesheet_file_modal" ref="upload_timesheet_file_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <!-- Different modal header depending on type file being uploaded for -->
        <h1><i class="fas fa-file-upload"></i> &nbsp; <span>Upload Timesheet File</span></h1>
        <p id="mh-info">Upload your timesheet using a file from external software</p>
      </div>
      <button v-if="!saving" id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <ValidationObserver ref="uploadTimesheetFileForm" slim>
      <form role="form" @submit.prevent="upload_file()">
        <div class="row">
          <!-- WARNING -->
          <div class="col-12">
            <h3 class="red_color">The timesheet file you select to upload must match the template format agreed with Genius Money.</h3>
            <p><strong>If you receive validation errors when trying to upload your timesheet file.</strong><br>
              Use the following link to download an example template file for your company so that you can check you are uploading a file which matches the specification
              Genius have for your upload.</p>
            <p><a href="#" @click="downloadTimesheetTplFile()">
              Download timesheet file
            </a></p>
          </div>

          <div class="col-12 form-group">
            <file_input @file-chosen="file_select($event)" :required="true" :selected_file="file"
                        :hidden_id="'timesheet_file'" :file_error_name="'Timesheet File'"
                        :accepted_file_type="'.xlsx,.csv'"></file_input>
          </div>
          <!--          Column errors & empty file -->
          <div class="col-12" v-if="show_column_errors && file !== null">
            <div>
              <div class="vvERROR vvError_icon"><i class="fas fa-exclamation-triangle"></i></div>
              <div class="vvError_messages">
                <p class="vvERROR font-weight-bold mb-0">{{ error_message }}</p>
                <p class="vvERROR mb-1" v-if="errors.length > 0">The following column headers do not match the expected template</p>
                <ul v-if="errors.length > 0">
                  <li class="vvERROR" v-for="error in errors">Column {{ numToSSColumn(error.column_index + 1) }}<br>
                    <strong>Found :</strong> {{ error.column_header_value }} <strong>Expected&nbsp;:</strong>&nbsp;{{ error.expected_header_value }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!--          Data errors -->
          <div class="col-12" v-if="show_data_errors && file !== null">
            <div>
              <div class="vvERROR vvError_icon"><i class="fas fa-exclamation-triangle"></i></div>
              <div class="vvError_messages">
                <p class="vvERROR font-weight-bold mb-0">{{ error_message }}</p>
                <p class="vvERROR mb-1" v-if="errors.length > 0">The following data (rows) have errors meaning the file cannot be imported</p>
                <ul v-if="errors.length > 0" style="max-height: 300px;overflow: scroll;list-style-type:none;padding-left: 0;">
                  <li class="vvERROR mb-2" v-for="(validation_errors) in errors">
                    <div class="font-weight-bold mb-2">Data Row: {{ validation_errors.row_index }}</div>
                    <ul class="pl-5 mb-2" style="list-style-type: disc;" v-for="(column_errors, column) in validation_errors.errors">
                      <div style="margin-left: -16px;"><u>{{ capitalizeFirst(column) }}</u></div>
                      <li class="vvERROR" v-for="error in column_errors">{{ error }}</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <hr>
          </div>
          <div class="col-12">
            <div class="float-right">
              <button :disabled="saving || file === null" class="btn orcaBtn sm_btn" type="submit">
                <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Uploading ...</span>
                <span v-else>UPLOAD TIMESHEET FILE</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import file_input from 'partials/files/fileInput';

export default {
  name: "select_timesheet_file_to_upload",
  components: {file_input},
  data() {
    return {
      file: null,
      saving: false,

      show_column_errors: false,
      show_data_errors: false,
      error_message: '',
      errors: {}
    }
  },
  methods: {
    capitalizeFirst(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    /**
     * hide modal
     */
    hideModal() {
      this.$refs.upload_timesheet_file_modal.hide();
      this.$store.commit('HIDE_TIMESHEET_FILE_UPLOAD_MODAL');
    },
    /**
     * update file when selection made
     */
    file_select(file) {
      this.file = file
    },
    /**
     * UPLOAD FILE FUNCTION
     */
    upload_file() {
      this.$refs.uploadTimesheetFileForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.uploadTimesheetFileForm);
        }
        else {
          this.saving = true;
          let formData = new FormData();
          formData.append('company_id', this.$store.state.client_timesheets.timesheet_file_upload.company_id)
          formData.append('submission_date', this.$store.state.client_timesheets.timesheet_file_upload.submission_date.end_date)
          formData.append('timesheet_template_name', this.$store.state.client_timesheets.timesheet_file_upload.timesheet_template_name)
          formData.append('timesheet_file', this.file)
          axios.post(this.crmApiPath + 'timesheet/import/file', formData, {headers: {'Content-Type': 'application/json'}}).then((data) => {
            // column errors || file empty
            if (!data.data.success && data.data.type === 'column') {
              this.saving = false;
              this.show_column_errors = true;
              this.error_message = data.data.message;
              this.errors = data.data.validation_errors
            }
            // data errors ||
            else if (!data.data.success && data.data.type === 'data') {
              this.saving = false;
              this.show_data_errors = true;
              this.error_message = data.data.message;
              this.errors = data.data.validation_errors
            }
            // file passed validations
            else {
              // console.log(data.data)
              this.hideModal();
              this.$store.commit('SHOW_TIMESHEET_FILE_UPLOAD_PREVIEW', {
                'imported_data': data.data.data
              })
              this.$nextTick(() => this.$root.$emit('bv::show::modal', 'preview_timesheet_file_modal'));
            }
          })
        }
      })
    },
    downloadTimesheetTplFile() {
      this.templateDownloading = true;
      axios.post(this.crmApiPath + 'timesheet/download_timesheet_tpl', {
          company_id: this.$store.state.client_timesheets.timesheet_file_upload.company_id,
          submission_date: this.$store.state.client_timesheets.timesheet_file_upload.submission_date.end_date
      }).then((response) => {
        this.templateDownloading = false;
        const filename = response.headers["custom-filename"];
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      });
    },
  },
  watch: {
    'file'(file) {
      if (file === null) {
        this.show_column_errors = false
        this.show_data_errors = false
        this.error_message = ''
        this.errors = {}
      }
    }
  }
}
</script>

<style lang="scss">
.vvError_icon, .vvError_messages {
  display:        inline-block;
  vertical-align: top;
}

.vvError_icon {
  margin-right: 5px;
  width:        20px;
}

.vvError_messages {
  width: calc(100% - 30px);
}
</style>
